import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryConcertOffersDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Concert Battery offers for the proposal's current server price, with the
 * saved selection and the server's own select / refresh capabilities. Reading
 * never reprices: a stale price comes back as `pricing_required` instead.
 */
export default function useBatteryConcertOffers(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatteryConcertOffersDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.concertOffers(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getConcertOffers(proposalId)
    },
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
